module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-home",
    attrs: {
      "id": "top"
    }
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (!_vm.loading && _vm.props) ? _c('div', [_c('VueTrigger', {
    attrs: {
      "function1": _vm.navScrolled,
      "function2": _vm.notScrolled
    }
  }), _c('HeroHome', {
    attrs: {
      "props": _vm.props.acf.hero_home
    }
  }), _c('HomeTagline', {
    attrs: {
      "props": _vm.props.acf.tagline
    }
  }), _c('TileSection', {
    attrs: {
      "props": _vm.props.acf.tiles
    },
    scopedSlots: _vm._u([{
      key: "image",
      fn: function(props) {
        return _c('div', {
          staticClass: "image"
        }, [_c('ImgBox', {
          attrs: {
            "props": props.content
          }
        })], 1)
      }
    }, {
      key: "title",
      fn: function(props) {
        return _c('div', {
          staticClass: "text"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content
          }
        })], 1)
      }
    }], null, false, 258499146)
  }), _c('HeaderSection', {
    staticClass: "pages-home__why",
    attrs: {
      "props": _vm.props.acf.header2
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(props) {
        return _c('div', {
          staticClass: "title"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content
          }
        })], 1)
      }
    }, {
      key: "subheader",
      fn: function(props) {
        return _c('div', {
          staticClass: "subtitle"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content
          }
        })], 1)
      }
    }, {
      key: "body",
      fn: function(props) {
        return _c('div', {
          staticClass: "body pages-home__container"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content
          }
        })], 1)
      }
    }], null, false, 4110106365)
  }), _c('TabHeader', {
    staticClass: "pages-home__tabs",
    attrs: {
      "props": _vm.props.acf.tabs
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _c('div', {
          staticClass: "tab"
        }, [_c('div', {
          staticClass: "tab--hero"
        }, [_c('ImgBox', {
          attrs: {
            "props": props.content.hero
          }
        }), _c('div', {
          staticClass: "textbox"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content.hero_text
          }
        })], 1)], 1), _c('div', {
          staticClass: "tab--title1"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content.title1
          }
        })], 1), _c('div', {
          staticClass: "tab--body1"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content.body1
          }
        })], 1), _c('div', {
          staticClass: "tab--title2"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content.title2
          }
        })], 1), _c('div', {
          staticClass: "tab--body2"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content.body2
          }
        })], 1)])
      }
    }], null, false, 3999304696)
  }), _c('div', {
    staticClass: "pages-home__subfooter"
  }, [_vm._v("So you're choice is as simple as ABC for choosing an orthodontist Lake Nona!")]), _c('ParallaxSection', {
    attrs: {
      "props": _vm.props.acf.parallax1
    },
    scopedSlots: _vm._u([{
      key: "image",
      fn: function(props) {
        return _c('div', {
          staticClass: "image"
        }, [_c('ImgBox', {
          attrs: {
            "props": props.content
          }
        })], 1)
      }
    }, {
      key: "header",
      fn: function(props) {
        return _c('div', {
          staticClass: "textfirst"
        }, [_c('div', {
          staticClass: "text1"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content.text1
          }
        })], 1)])
      }
    }], null, false, 168170603)
  }), _c('PercentSection', {
    attrs: {
      "props": _vm.props.acf.percent
    }
  }), _c('ParallaxSection', {
    attrs: {
      "props": _vm.props.acf.parallax2
    },
    scopedSlots: _vm._u([{
      key: "image",
      fn: function(props) {
        return _c('div', {
          staticClass: "image"
        }, [_c('ImgBox', {
          attrs: {
            "props": props.content
          }
        })], 1)
      }
    }, {
      key: "header",
      fn: function(props) {
        return _c('div', {
          staticClass: "textlast"
        }, [_c('div', {
          staticClass: "text1"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content.text1
          }
        })], 1), _c('div', {
          staticClass: "button"
        }, [_c('RouterButton', {
          attrs: {
            "props": props.content.button
          }
        })], 1), _c('div', {
          staticClass: "text2"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content.text2
          }
        })], 1)])
      }
    }], null, false, 1325925358)
  }), _c('FlexibleFinancingSection', {
    attrs: {
      "props": _vm.props.acf.financing
    }
  }), _c('div', {
    staticClass: "pages-home__invisalign"
  }, [_c('div', {
    staticClass: "pages-home__invisalign--left"
  }, [_c('TextBox', {
    attrs: {
      "props": _vm.props.acf.text_svg.text
    }
  })], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f615506a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/home/home.pug
// module id = 610
// module chunks = 1